module.exports = __webpack_public_path__ + "img/CAL-IEC-charge.c2d296e702ca5ae2232c19b4ef9740f3.avif";